<template>
  <b-overlay class="loader" no-wrap fixed :show="isShow">
    <template #overlay>
      <div class="text-center">
        <div>
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <div class="pt-5">Loading process. It may take a few seconds.</div>
      </div>
    </template>
  </b-overlay>
</template>

<script lang="ts">
import { BOverlay, BSpinner } from 'bootstrap-vue-next'
import { defineComponent, computed } from 'vue'
import { DEFAULT_LOADER } from '@/const/LoadersNames'
import { useUiStore } from '@/store/ui'

export default defineComponent({
  name: 'LoaderDefault',
  components: { BOverlay, BSpinner },
  setup() {
    const uiStore = useUiStore()
    const defaultLoader = computed(() => uiStore.loader ?? { name: null, show: false })
    const isShow = computed(() => defaultLoader.value.name === DEFAULT_LOADER && Boolean(defaultLoader.value.show))

    return {
      isShow,
    }
  },
})
</script>
